"use client";

import { useEffect, useRef } from "react";
import { redirectToLogin } from "@/lib/redirectToLogin";

type Auth0AutoRedirectProps = {
  callbackUrl: string;
  /**
   * Auth0 connection name resolved from a partner's `?tenant=` alias (APD-1381). When set, Auth0
   * skips its connection picker and goes straight to that IdP. Undefined = ordinary login.
   */
  connection?: string;
};

/**
 * Full navigation to `/auth/login` (Auth0 SDK v4) — use `<a>`/location, not client-side `<Link>`,
 * per SDK guidance.
 */
export default function Auth0AutoRedirect({ callbackUrl, connection }: Auth0AutoRedirectProps) {
  const hasTriggeredRedirectRef = useRef(false);

  useEffect(() => {
    if (hasTriggeredRedirectRef.current) {
      return;
    }
    hasTriggeredRedirectRef.current = true;
    redirectToLogin(callbackUrl, connection);
  }, [callbackUrl, connection]);

  return (
    <main style={{ padding: 24, fontFamily: "system-ui" }}>
      <p>Redirecting to Auth0...</p>
    </main>
  );
}
